import React from 'react'
import { ResponsivePie } from '@nivo/pie'

const LiveRaceAndEthnicityChart = props => {
  const defaultWidth = 420
  const defaultHeight = 250

  const width = props.width || defaultWidth
  const height = props.height || defaultHeight

  const format = v => `${v}%`

  let chartStyles
  let legendStyles

  if (width >= 420) {
    chartStyles = {
      innerRadius: 0.5,
      margin: { top: 0, right: 160, bottom: 0, left: 0 },
      enableArcLinkLabels: false,
    }

    legendStyles = [
      {
        anchor: 'right',
        direction: 'column',
        translateX: 100,
        itemsSpacing: 10,
        itemWidth: 100,
        itemHeight: 18,
        symbolSize: 10,
        symbolShape: 'square',
      },
    ]
  } else {
    chartStyles = {
      innerRadius: 0.5,
      margin: { top: 0, right: 0, bottom: 150, left: 0 },
      enableArcLinkLabels: false,
    }

    legendStyles = [
      {
        anchor: 'top',
        direction: 'column',
        translateY: 300,
        itemsSpacing: 10,
        itemWidth: 100,
        itemHeight: 8,
        symbolSize: 10,
        symbolShape: 'square',
      },
    ]
  }

  return (
    <div style={{ height: `${height}px`, width: `${width}px` }}>
      <ResponsivePie
        data={props.data}
        valueFormat={format}
        legends={legendStyles}
        colors={props.data.map(d => d.color)}
        arcLabelsRadiusOffset={0.8}
        arcLabel={false}
        {...chartStyles}
      />
    </div>
  )
}

export default LiveRaceAndEthnicityChart
